// @flow

import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';

// redux
import { connect } from 'react-redux';
import { fetchFilesForResType } from '../../actions/files';
import { fetchAggregatedResource } from '../../actions/resources';

import asyncComponent from '../async-component';

import AppView from '../layouts/AppView';

import Text from './Typography';
import FileCard from '../resource-file-card';
import PrivateComponent from '../shared/PrivateComponent';
import Loader from '../shared/Loader';
import RecordShareAlert from '../shared-resource-banner';
import TimelineCard from '../immunization-timeline-card';

// models
import type { ResourceType } from '../../types/resource';
import type { InstitutionType, InstitutionAddress } from '../../types/institution';
import type { RecordFileType } from '../../types/file';

import resourceService from '../../services/resource-service';
import icon from '../../assets/icons/ic-processing.svg';

const AsyncResourceFile = asyncComponent(() => import('../resource-file'));

type Props = {
  provider: InstitutionType,
  fetchFiles: (type: string) => RecordFileType[],
  fetchProviderAddress: (id: number) => InstitutionAddress,
  fetchAggregatedResource: any,
  resource: ResourceType,
  providerAddress: {},
  institution: {},
  providerAddressID: number,
  viewType?: string,
  fileviewerReg: boolean,
  location: {},
  match: {},
  loading?: boolean,
  sharedAt?: string,
  token?: string,
  files?: [],
} & WithTranslation
class AggregatedResource extends Component<Props> {
  state = {
    timeline: ''
  };

  componentWillMount() {
    const { location, resource } = this.props;
    const aggResource = resource ||
      (location && location.state && location.state.resource);
    if (!resource) this.props.fetchFiles(aggResource && aggResource.resource_type);
    this.props.fetchAggregatedResource(aggResource);
    resourceService
      .vaccinations()
      .then((timeline) => this.setState({ timeline }))
      .catch((err) => this.setState({ err }));
  }

  props: Props

  render() {
    const { viewType, location,
      sharedAt, token, resource, files, t } = this.props;

    const loading = files && files.length <= 0;

    const OCRedResources = resource && resource.resources &&
      resource.resources.filter((r) => (r.reviewed || (r.source !== 'patient' && r.source !== null)));
    const showProcessingView = OCRedResources && OCRedResources.length === 0 && files && files.length > 0;

    return (
      resource &&
        <AppView
          viewType={viewType || 'private-body'}
          pageTitle={resource.title}
          headerClass={`record-detail__header is-bg-${resource.color}`}
          // for shared records
          frameless={token}
          shareBanner={token &&
            <RecordShareAlert
              shared_at={sharedAt}
              user={resource.user}
              token={token}
            />
          }
        >

          <main className='content-container record-detail wide'>
            {loading && <Loader isLoading />}

            {/* SIDEBAR */}
            <aside className='record-detail__sidebar'>
              <div>
                {files && files.length > 0 &&
                  <Text h3 className='record-detail__section-title'>
                    <Trans i18nKey='files' t={t}>{{ num: files.length }}</Trans>
                  </Text>
                }
                {files && files.map((file, i) => (
                  <FileCard
                    aggregated
                    token={token}
                    key={i}
                    recordID={resource && resource.id}
                    file={file}
                    openFile={this.openViewer}
                  />
                ))}
              </div>
            </aside>

            {/* BODY */}
            {!loading &&
            <section className='record-detail__section' style={{ marginTop: 40 }}>
              {showProcessingView &&
                <div className='immunizations__processing'>
                  <img src={icon} alt={t('processing_icon')} className='immunizations__processing-icon' />
                  <Text h2 align='center' className='immunizations__processing-title'>
                    {t('processing_title')}
                  </Text>
                  <Text paragraph align='center'>{t('processing_subtitle')}</Text>
                </div>}
              {!showProcessingView &&
                <div className='immunizations__timeline' style={{ marginTop: 0 }}>
                  <div className='immunizations__timeline-header'>
                    <Text h1 align='center' className='immunizations__processing-title'>
                      {t('timeline_title')}
                    </Text>
                    <Text paragraph bold className='immunizations__processing-title'>
                      {t('info_attribution_text')}
                      <Text link href={t('info_source_URL')}>{t('view_guide')}</Text>
                    </Text>
                  </div>
                  {this.state.timeline && this.state.timeline.map((item, i) => (
                    <TimelineCard item={item} key={i} />
                  ))}
                </div>}
            </section>}

            {/* FILE VIEWER -- REGULAR */}
            {!token &&
              <Route
                exact
                path='/resource/immunization/file/:file_id'
                component={PrivateComponent(AsyncResourceFile)}
                location={location}
              />
            }
          </main>
        </AppView>
    );
  }
}

const mapStateToProps = (appState) => ({
  resource: appState.resource && appState.resource.aggregatedResource,
  files: appState.files && appState.files.allFiles && appState.files.allFiles.files
});

const mapDispatchToProps = (dispatch) => ({
  fetchFiles: ((type) => dispatch(fetchFilesForResType(type))),
  fetchAggregatedResource: ((resource) => dispatch(fetchAggregatedResource(resource)))
});

export default withTranslation('aggregatedResource')(
  connect(mapStateToProps, mapDispatchToProps)(AggregatedResource)
);



// WEBPACK FOOTER //
// ./src/components/shared/AggregatedResource.js